import React, { useContext, useEffect, useState } from 'react';
import { Loan, Task, TaskResponse, TaskState } from 'gql/graphql';
import { CardLoanTasksProps } from 'components/Atoms/Cards/CardLoanTasks/CardLoanTasks';
import Insurance from './Insurance';
import { ModuleKeys } from 'services/task/modules-keys.constanst';
import { OBIE_LINK } from './insurance.constant';
import { useGetLoanDocByLoan } from '../../../../../services/loan/querys';
import CircleTag from '../../../../../components/Atoms/Tags/CircleTag/CircleTag';

interface Props {
  tasks?: Task[] | any[],
  loan?: Loan | any;
}

const useCardInsurance = ({ tasks, loan }: Props) => {
  const { data: loanDocs } = useGetLoanDocByLoan({ variables: { loanId: loan?._id } });

  const [dataTask, setDataTask] = useState<Task>();
  const [stepNow, setStepNow] = useState<TaskResponse>();
  const [responsesStep1, setResponsesStep1] = useState<any[]>();
  const [responseDocs, setResponseDocs] = useState<TaskResponse>();

  useEffect(() => {
    if (tasks) {
      const data: Task = tasks.find((item) => item.key === ModuleKeys.INSURANCE);
      setDataTask(data);
      
      const step1: any = data?.responses?.filter((item) => item.step === 1);
      setResponsesStep1(step1);
      const responseDocs = data?.responses.find(response => response.key === 'insurance-doc');
      setResponseDocs(responseDocs);

      if (data?.responses.length > 0)
        setStepNow(data?.responses.reduce((max, obj) => obj.step > max.step ? obj : max, data?.responses[0]));
    }
  }, [tasks]);

  const getFilesCircle = () => {
    const allFiles = responseDocs?.files || [];

    const filesWithoutError = allFiles.filter((item: any) => item.state !== 'request_error');
    return filesWithoutError;
  };

  const getTotalApproved = () => {
    const filesWithoutError = responseDocs?.files?.filter((item: any) => item.state !== 'request_error') || [];
    return filesWithoutError.filter((item: any) => item.state !== 'draft').length;
  };

  //Cuando el contact es aprobado por el processing team y no hay un loan documents de insurance
  //El estado se muestra en Review, no en Approved
  const isLoanDocInsurance = loanDocs?.find(item => item.key === 'insurance');

  /** IMPORTANTE: Si se cambia la logica de transformState, se debe modificar el archivo LoanCard.tsx Linea 73-79: tasksForRender */
  const transformState = !isLoanDocInsurance && dataTask?.metadata?.contactedApproved && dataTask?.state === TaskState.Approved? TaskState.Review: dataTask?.state;

  const isObie = responsesStep1?.find((item: any) => item.key === 'obie')?.key === 'obie';
  const isContact = responsesStep1?.find((item: any) => item.key === 'contact')?.state === TaskState.Approved;
  const isDocument = responsesStep1?.find((item: any) => item.key === 'documents')?.state === TaskState.Approved

  const isAwaitingAction = dataTask?.state === TaskState.Review && dataTask?.metadata?.reviewRename === 'MANUAL ACTION' && !isContact;

  // ─── DEV DUMMY — cambiar DUMMY_ENABLED a false antes de hacer commit ─────────
  const DUMMY_ENABLED = false;
  const DUMMY = { state: TaskState.Review, isContact: true, isObie: false };
  // ─────────────────────────────────────────────────────────────────────────────
  const _state      = (DUMMY_ENABLED && dataTask) ? DUMMY.state     : transformState;
  const _isContact  = DUMMY_ENABLED ? DUMMY.isContact : isContact;
  const _isObie     = DUMMY_ENABLED ? DUMMY.isObie    : isObie;
  const _isAwaitingAction = _state === TaskState.Review && dataTask?.metadata?.reviewRename === 'MANUAL ACTION' && !_isContact;

  const card: CardLoanTasksProps =
  {
    key: ModuleKeys.INSURANCE,
    title: <h4 className="h4">Insurance</h4>,
    steps: 2,
    stepCurrent: stepNow?.step || 0,
    type: 'quick task',
    state: _state,
    stateRename: _isAwaitingAction ? { REVIEW: 'AWAITING ACTION' } : undefined,
    actions: dataTask ? [<Insurance key={1} task={dataTask} />] : [],
    text: (
      <div>
        {(_state === TaskState.Draft || _state === TaskState.Incomplete) && (
          <p className="body-card">
            My insurance is{' '}
            <span className="body-card-bold-line">not approved</span>
          </p>
        )}

        {dataTask && !(_state === TaskState.Draft || _state === TaskState.Incomplete) && (
          <>
            <p className="body-card">
              My insurance is{' '}
              <span className={`body-card-bold-line body-card-bold-line-${_state}`}>
                {_state === TaskState.Approved? '': 'not '}approved
              </span>
            </p>

            {(_isContact || _isObie) && _state === TaskState.Review &&
              <div
                className={`box-message-state-${'review'}`}
              >
                <span>
                  {_isContact && 'We’ve reached out to your agent and will update you. '}
                  {_isObie && !(isDocument && _isContact) && 'Get your insurance quote and instructions '}
                </span>
                {_isObie && !(isDocument && _isContact) &&
                  <span
                    className={`body-card-bold-line`}
                    style={{ textDecoration: 'underline', cursor: 'pointer' }}
                    onClick={() => window.open(OBIE_LINK, '_blank')}
                  >
                    here
                  </span>
                }
              </div>
            }
          </>
        )}
      </div>
    ),
    text2: (!responseDocs) ? null : (
      <div className='docs-section' style={{ marginTop: _isContact || _isObie? 3: 20, marginBottom: 5 }}>
        <div className='labels'>
          <p className={`body-regular body-regular-bold`}>
            Document status
          </p>
          <p className={`body-card`}>
            {getTotalApproved()}/{getFilesCircle().length} submitted
          </p>
        </div>
        <div className={`circles-tags`}>
          {getFilesCircle().map((_response, index) => {
            let _state = _response?.state?.toUpperCase() || 'DRAFT';

            return (<CircleTag
              key={index}
              state={_state}
              tagKey={_state}
              isIconState={true}
            />);
          })}
        </div>
      </div>
    )
  };

  if (!dataTask)
    return { card: null, transformState: undefined };

  return {
    card,
    dataTask,
    transformState
  };
};

export default useCardInsurance;